import axios from 'axios';
import { linkedinConfig } from './config';

const N8N_API_URL = 'https://aai.bigg.co.uk/webhook';

const axiosConfig = {
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
};

export async function getAuthUrl(redirectUri, connectionId) {
  console.log('Generating LinkedIn auth URL with:', {
    redirectUri,
    connectionId,
    clientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
    scopes: linkedinConfig.requiredScopes
  });

  const stateObj = {
    service: 'linkedin_profile',
    connectionId: connectionId
  };
  
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
    redirect_uri: redirectUri,
    state: btoa(JSON.stringify(stateObj)),
    scope: linkedinConfig.requiredScopes
  });

  const authUrl = `${linkedinConfig.authEndpoint}?${params.toString()}`;
  console.log('Generated LinkedIn auth URL:', authUrl);
  return authUrl;
}

export async function exchangeCodeForToken(code, redirectUri) {
  try {
    console.log('Starting LinkedIn token exchange process...', {
      code,
      redirectUri,
      clientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
      url: `${N8N_API_URL}/linkedin-exchange-token`
    });
    
    // Use N8N endpoint to handle token exchange and profile fetch
    const response = await axios.post(
      `${N8N_API_URL}/linkedin-exchange-token`, 
      {
        code,
        redirectUri,
        clientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
        clientSecret: process.env.REACT_APP_LINKEDIN_CLIENT_SECRET
      },
      axiosConfig
    );

    console.log('Token exchange response:', response.data);

    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to exchange token');
    }

    // N8N should return both token and profile data
    return {
      success: true,
      data: {
        accessToken: response.data.accessToken,
        expiresIn: response.data.expiresIn,
        profile: response.data.profile
      }
    };

  } catch (error) {
    console.error('LinkedIn auth error:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      url: error.config?.url
    });
    return {
      success: false,
      error: error.response?.data?.error || error.message
    };
  }
}

export async function testConnection(credentials) {
  try {
    console.log('Testing LinkedIn connection...');
    
    // Use N8N endpoint to test connection
    const response = await axios.post(
      `${N8N_API_URL}/linkedin-test-connection`,
      {
        accessToken: credentials.accessToken,
        profileId: credentials.profile.id
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('Test response:', response.data);

    // Check if we got the userinfo response directly
    if (response.data.sub) {
      return {
        success: true,
        data: {
          id: response.data.sub,
          name: response.data.name,
          email: response.data.email,
          picture: response.data.picture,
          locale: response.data.locale
        }
      };
    }

    // Otherwise check for success flag
    if (!response.data.success) {
      throw new Error(response.data.error || 'Connection test failed');
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('LinkedIn test connection error:', error.response?.data || error);
    return {
      success: false,
      error: error.response?.data?.error || error.message
    };
  }
} 